import { FC, useMemo } from "react";
import { StuntTypeCompProp } from "../../../CustomTypes/Filters";
import * as CONSTANTS from '../../../Constants'
//import { useDashboardData } from "../../../Hooks/useDashboard";
import { SelectField } from "@sainsburys-tech/luna-form";
import { useHookForApi } from "../../../Hooks/useHookForApi";
import { errorToast } from "../../../Utils/toastMessage";
import CustomToast from "../../CustomToast/CustomToast";

const StuntType: FC<StuntTypeCompProp> = (childToParent) => {
    const stuntTypeMasterServiceUrl = CONSTANTS.SERVICES.LOADSTUNTTYPEMASTERDATA
    const onSuccess = (data: any) => {
        if (data.isAxiosError && data.name === 'Error' && data.message === "Network Error") {
            errorToast(JSON.stringify(`Unable to connect with StoreOrder service and possible reason is: (${data})`));
          }
    };
    const onError = (error: any) => {
        //console.clear()
    };
    
    const {
        //isLoading,
        data:response,
    //} = useDashboardData(onSuccess, onError, stuntTypeMasterServiceUrl);
    } = useHookForApi(onSuccess, onError,0,0, stuntTypeMasterServiceUrl);

    let stuntTypeMasterData: { label: string, value: string }[] | undefined = [];
    stuntTypeMasterData = useMemo(() => response?.data, [response?.data]);

    const handleChange = (event:any)=>{
        childToParent.childToParent(event.target.value);
    }
    return <>
        <div>
            <SelectField
                name="stuntType"
                options={stuntTypeMasterData ? stuntTypeMasterData : []}
                onChange={(e)=>handleChange(e)}
                placeholder="Select Stunt Type"
                //label="Stunt Type"
            />
        </div>
        <CustomToast />
    </>
}

export default StuntType;

